import product1 from '../../images/dsc01213_1.jpg';
import product2 from '../../images/transportealonso.jpg';
import product3 from '../../images/product-3.jpg';
import sweet1 from '../../images/sweet3.jpg';
import sweet2 from '../../images/sweet-2.jpg';
import sweet3 from '../../images/sweet-3.jpg';
const web='https://aridosbariloche.web.app/';
const whatAlonso=`https://api.whatsapp.com/send?phone=5492944581597&text=Hola%20Transporte%20Alonso.%20Me%20contacto%20desde%20la%20WEB%20Aridos%20Bariloche.%20${web}%20.Quisiera%20realizar%20la%20siguiente%20consulta:`;
const whatPiche=`https://api.whatsapp.com/send?phone=5492944633212&text=Hola%20Transporte%20Piche.%20Me%20contacto%20desde%20la%20WEB%20Aridos%20Bariloche.%20${web}%20.Quisiera%20realizar%20la%20siguiente%20consulta:`;
const whatSantino=`https://api.whatsapp.com/send?phone=5492944419106&text=Hola%20Transporte%20Santino.%20Me%20contacto%20desde%20la%20WEB%20Aridos%20Bariloche.%20${web}%20.Quisiera%20realizar%20la%20siguiente%20consulta:`;

export const productData = [
  {
    img: product1,
    alt: 'Transporte Piche',
    name: 'Transporte Piche',
    desc:
      'Mas de 20 años de experiencia en el Rubro',
    price: 'WhatssApp',
    button: '+5492944633212',
    link:whatPiche
  },
  {
    img: product2,
    alt: 'Transporte Alonso',
    name: 'Transporte Alonso',
    desc:
    'Mas de 20 años de experiencia en el Rubro',
      price: 'WhatssApp',
      button: '+5492944581597',
      link:whatAlonso
  },
  {
    img: product3,
    alt: 'Transporte Santino',
    name: 'Transporte Santino',
    desc:
    'Mas de 20 años de experiencia en el Rubro',
    price: 'WhatssApp',
    button: '+5492944419106',
    link:whatSantino
  }
];

export const productDataTwo = [
  {
    img: sweet2,
    alt: 'Transporte Alonso',
    name: 'Transporte Alonso',
    desc:
    'Mas de 20 años de experiencia en el Rubro',
      price: 'WhatssApp',
      button: '+5492944581597',
      link:whatAlonso
  },
  {
    img: sweet3,
    alt: 'Transporte Piche',
    name: 'Transporte Piche',
    desc:
      'Mas de 20 años de experiencia en el Rubro',
    price: 'WhatssApp',
    button: '+5492944633212',
    link:whatPiche
  },
  {
    img: sweet1,
    alt: 'Transporte Santino',
    name: 'Transporte Santino',
    desc:
    'Mas de 20 años de experiencia en el Rubro',
    price: 'WhatssApp',
    button: '+5492944419106',
    link:whatSantino
  }
];
